import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormStateEnum } from '@magieno/angular-advanced-forms';
import {
  RolloverPropertyTransferredSection84_1Options,
} from '../../../../../../../../../../../common/src/options/calculations/rollover/rollover-property-transferred-section-84_1.options';
import { merge, Subscription } from 'rxjs';
import {AdvancedFormGroup} from "@magieno/angular-advanced-forms";
import { AdvancedFormControl } from "@magieno/angular-advanced-forms";
import { Locale } from '@magieno/common';
import { CurrencyEnum } from '@magieno/common';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-rollover-property-section-84_1-form',
  templateUrl: './rollover-property-section-84_1-form.component.html',
  styleUrls: ['./rollover-property-section-84_1-form.component.scss'],
  standalone: false,
})
export class RolloverPropertySection84_1FormComponent implements OnInit, OnDestroy {

  isSection84_1Collapsed: boolean;
  isSection84_1Applicable: boolean;

  onFormChangeSubscription: Subscription;

  @Input()
  form: AdvancedFormGroup<RolloverPropertyTransferredSection84_1Options>;

  constructor(private readonly translateService: TranslateService,
              private readonly changeDetectorRef: ChangeDetectorRef) {

  }

  get currency(): CurrencyEnum {
    return CurrencyEnum.CAD;
  }

  get locale(): Locale {
    switch (this.translateService.currentLang) {
      case 'fr':
        return Locale.fr_CA;
      case 'en':
        return Locale.en_CA;
    }

    return Locale.fr_CA;
  }

  get actualCostOnJanuary1972OfTransferredShares(): AdvancedFormControl<number, number, number> {
    return this.form.formElements.actualCostOnJanuary1972OfTransferredShares as AdvancedFormControl<number, number, number>;
  }

  get areBuyerAndSellerAtArmsLength(): AdvancedFormControl<boolean, boolean, boolean> {
    return this.form.formElements.areBuyerAndSellerAtArmsLength as AdvancedFormControl<boolean, boolean, boolean>;
  }

  get areTransferredSharesCanadianShares(): AdvancedFormControl<boolean, boolean, boolean> {
    return this.form.formElements.areTransferredSharesCanadianShares as AdvancedFormControl<boolean, boolean, boolean>;
  }

  get areTransferredSharesCapitalPropertyForTheSeller(): AdvancedFormControl<boolean, boolean, boolean> {
    return this.form.formElements.areTransferredSharesCapitalPropertyForTheSeller as AdvancedFormControl<boolean, boolean, boolean>;
  }

  get capitalGainsOnTheShareDeclaredAfter1984(): AdvancedFormControl<number, number, number> {
    return this.form.formElements.capitalGainsOnTheShareDeclaredAfter1984 as AdvancedFormControl<number, number, number>;
  }

  get fairMarketValueOnValuationDayOfTransferredShares(): AdvancedFormControl<number, number, number> {
    return this.form.formElements.fairMarketValueOnValuationDayOfTransferredShares as AdvancedFormControl<number, number, number>;
  }

  get isBuyerACorporation(): AdvancedFormControl<boolean, boolean, boolean> {
    return this.form.formElements.isBuyerACorporation as AdvancedFormControl<boolean, boolean, boolean>;
  }

  get isCorporationForWhichSharesAreBeingSoldBecomingAtArmsLengthImmediatelyAfterTransaction(): AdvancedFormControl<boolean, boolean, boolean> {
    return this.form.formElements.isCorporationForWhichSharesAreBeingSoldBecomingAtArmsLengthImmediatelyAfterTransaction as AdvancedFormControl<boolean, boolean, boolean>;
  }

  get isSellerAnIndividualOrATrust(): AdvancedFormControl<boolean, boolean, boolean> {
    return this.form.formElements.isSellerAnIndividualOrATrust as AdvancedFormControl<boolean, boolean, boolean>;
  }

  get isSellerACanadianResident(): AdvancedFormControl<boolean, boolean, boolean> {
    return this.form.formElements.isSellerACanadianResident as AdvancedFormControl<boolean, boolean, boolean>;
  }

  get receivedDividendChoice83OnTransferredShares(): AdvancedFormControl<number, number, number> {
    return this.form.formElements.receivedDividendChoice83OnTransferredShares as AdvancedFormControl<number, number, number>;
  }

  get sellingFees(): AdvancedFormControl<number, number, number> {
    return this.form.formElements.sellingFees as AdvancedFormControl<number, number, number>;
  }

  get wereSharesAcquiredAfter1971(): AdvancedFormControl<boolean, boolean, boolean> {
    return this.form.formElements.wereSharesAcquiredAfter1971 as AdvancedFormControl<boolean, boolean, boolean>;
  }

  ngOnInit(): void {

    //todo change for merge of all values
    // this.onFormChangeSubscription = this.form.value.subscribe((value) => {
    //     this.refresh();
    // })

    this.onFormChangeSubscription = merge(
      this.areTransferredSharesCanadianShares.value$,
      this.areTransferredSharesCapitalPropertyForTheSeller.value$,
      this.isSellerAnIndividualOrATrust.value$,
      this.isSellerACanadianResident.value$,
      this.isBuyerACorporation.value$,
      this.areBuyerAndSellerAtArmsLength.value$,
      this.isCorporationForWhichSharesAreBeingSoldBecomingAtArmsLengthImmediatelyAfterTransaction.value$,
    ).subscribe((value) => {
      this.refresh();
    });
  }

  ngOnDestroy() {
    this.onFormChangeSubscription?.unsubscribe();
  }

  ngAfterViewInit() {
    this.refresh();
  }

  refresh() {
    this.handleSection84_1Visibility();
    this.changeDetectorRef.detectChanges();
  }

  disableAll() {
    this.areTransferredSharesCanadianShares.disable();
    this.areTransferredSharesCanadianShares.setValue(undefined);
    this.areTransferredSharesCanadianShares.state = FormStateEnum.Valid;
    this.areTransferredSharesCapitalPropertyForTheSeller.disable();
    this.areTransferredSharesCapitalPropertyForTheSeller.setValue(undefined);
    this.areTransferredSharesCapitalPropertyForTheSeller.state = FormStateEnum.Valid;
    this.isSellerAnIndividualOrATrust.disable();
    this.isSellerAnIndividualOrATrust.setValue(undefined);
    this.isSellerAnIndividualOrATrust.state = FormStateEnum.Valid;
    this.isSellerACanadianResident.disable();
    this.isSellerACanadianResident.setValue(undefined);
    this.isSellerACanadianResident.state = FormStateEnum.Valid;
    this.isBuyerACorporation.disable();
    this.isBuyerACorporation.setValue(undefined);
    this.isBuyerACorporation.state = FormStateEnum.Valid;
    this.areBuyerAndSellerAtArmsLength.disable();
    this.areBuyerAndSellerAtArmsLength.setValue(undefined);
    this.areBuyerAndSellerAtArmsLength.state = FormStateEnum.Valid;
    this.isCorporationForWhichSharesAreBeingSoldBecomingAtArmsLengthImmediatelyAfterTransaction.disable();
    this.isCorporationForWhichSharesAreBeingSoldBecomingAtArmsLengthImmediatelyAfterTransaction.setValue(undefined);
    this.isCorporationForWhichSharesAreBeingSoldBecomingAtArmsLengthImmediatelyAfterTransaction.state = FormStateEnum.Valid;
    this.disableSection84_1();
  }

  enableAll() {
    this.areTransferredSharesCanadianShares.enable();
    this.areTransferredSharesCapitalPropertyForTheSeller.enable();
    this.isSellerAnIndividualOrATrust.enable();
    this.isSellerACanadianResident.enable();
    this.isBuyerACorporation.enable();
    this.areBuyerAndSellerAtArmsLength.enable();
    this.isCorporationForWhichSharesAreBeingSoldBecomingAtArmsLengthImmediatelyAfterTransaction.enable();
    // this.enableSection84_1();
  }

  handleSection84_1Visibility() {
    const isSection84_1Applicable =
      this.form.value.areTransferredSharesCanadianShares === true &&
      this.form.value.areTransferredSharesCapitalPropertyForTheSeller === true &&
      this.form.value.isSellerAnIndividualOrATrust === true &&
      this.form.value.isSellerACanadianResident === true &&
      this.form.value.isBuyerACorporation === true &&
      this.form.value.areBuyerAndSellerAtArmsLength === true &&
      this.form.value.isCorporationForWhichSharesAreBeingSoldBecomingAtArmsLengthImmediatelyAfterTransaction === true;

    // if(this.isSection84_1Applicable !== isSection84_1Applicable) {
    this.isSection84_1Applicable = isSection84_1Applicable;

    if (isSection84_1Applicable === true) {
      this.enableSection84_1();
    } else {
      this.disableSection84_1();
    }
    // }

    //if(notIsSection84_1Applicable === this.isSection84_1Applicable /*|| (this.isSection84_1Applicable === undefined && notIsSection84_1Applicable === true)*/){
    //     this.isSection84_1Applicable = !notIsSection84_1Applicable;
    //     if (notIsSection84_1Applicable === false) {
    //         this.enableSection84_1();
    //     } else {
    //         this.disableSection84_1();
    //     }
    //}
  }

  disableSection84_1() {
    this.isSection84_1Collapsed = true;
    // this.paidUpCapitalOfGiftedShares.state = FormStateEnum.Valid);
    // this.nonShareConsideration.disable();
    // this.nonShareConsideration.setValue(undefined);
    // this.nonShareConsideration.state = FormStateEnum.Valid);
    this.capitalGainsOnTheShareDeclaredAfter1984.disable();
    this.capitalGainsOnTheShareDeclaredAfter1984.setValue(undefined);
    this.capitalGainsOnTheShareDeclaredAfter1984.state = FormStateEnum.Valid;
    this.sellingFees.disable();
    this.sellingFees.setValue(undefined);
    this.sellingFees.state = FormStateEnum.Valid;
    this.wereSharesAcquiredAfter1971.disable();
    this.wereSharesAcquiredAfter1971.setValue(undefined);
    this.wereSharesAcquiredAfter1971.state = FormStateEnum.Valid;
    this.disableAcquiredBefore1971();
  }

  disableAcquiredBefore1971() {
    this.fairMarketValueOnValuationDayOfTransferredShares.disable();
    this.fairMarketValueOnValuationDayOfTransferredShares.setValue(undefined);
    this.fairMarketValueOnValuationDayOfTransferredShares.state = FormStateEnum.Valid;
    this.actualCostOnJanuary1972OfTransferredShares.disable();
    this.actualCostOnJanuary1972OfTransferredShares.setValue(undefined);
    this.actualCostOnJanuary1972OfTransferredShares.state = FormStateEnum.Valid;
    this.receivedDividendChoice83OnTransferredShares.disable();
    this.receivedDividendChoice83OnTransferredShares.setValue(undefined);
    this.receivedDividendChoice83OnTransferredShares.state = FormStateEnum.Valid;
  }

  enableSection84_1() {
    this.isSection84_1Collapsed = false;
    // this.nonShareConsideration.enable();
    this.capitalGainsOnTheShareDeclaredAfter1984.enable();
    this.sellingFees.enable();
    this.wereSharesAcquiredAfter1971.enable();
    this.enableAcquiredBefore1971();
  }

  enableAcquiredBefore1971() {
    this.fairMarketValueOnValuationDayOfTransferredShares.enable();
    this.actualCostOnJanuary1972OfTransferredShares.enable();
    this.receivedDividendChoice83OnTransferredShares.enable();
  }
}
